import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { RowClassArgs, RowArgs } from '@progress/kendo-angular-grid';
import { fadeInOnEnterAnimation } from 'angular-animations';
import { ListService } from 'src/app/_services/list.service';
import { environment } from 'src/environments/environment';
import { Asset } from 'src/app/_models/asset';

@Component({
  selector: 'app-asset-selection',
  templateUrl: './asset-selection.component.html',
  styleUrls: ['./asset-selection.component.scss'],
  animations: [fadeInOnEnterAnimation()]
})
export class AssetSelectionComponent implements OnInit {
  baseUrl = environment.apiUrl;
  @Output()
  assetSelected: EventEmitter<Asset> = new EventEmitter<Asset>();
  @Input()
  method: string;
  constructor(private listService: ListService) {}

  ngOnInit() {}
  selectionChange(data) {
    data.selectedRows.forEach((row: RowArgs) => {
      this.assetSelected.emit(row.dataItem);
    });
  }

  public rowCallback(context: RowClassArgs) {
    const isEven = context.index % 2 === 0;
    return {
      even: isEven,
      odd: !isEven
    };
  }
}
